<template>
  <div id="app">
    <index></index>
    <slider-menu :type="1"></slider-menu>
  </div>
</template>

<script>
import index from "./components/index/index";
import sliderMenu from "./components/common/sliderMenu";
(function(doc, win) {
  // rem 自适应
  var defaulfFontSize = "85.3333333px";
  var docEl = doc.documentElement,
    // docEl.style.fontSize = defaulfFontSize + 'px';
    resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
    recalc = function() {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      if (clientWidth > 640) {
        docEl.style.fontSize = defaulfFontSize;
      } else {
        docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
      }
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener("DOMContentLoaded", recalc, false);
})(document, window);

export default {
  name: "App",
  data() {
    return {
      appkey: { appkey: "4b9f40822ddd5cd5", version_no: "apr_2010_build01" },
      param: {},
      wxshare_imgurl:
        "https://i0.ulecdn.com/i/event/2019/0919/main/images/shareLogo.png",
      wxshare_title: "今年919格外不一样，优惠不停等你来！",
      wxshare_desc: "919丰收欢乐购，1亿购物津贴等你领！",
      wxshare_link: location.href
    };
  },
  mounted() {},
  created() {
    if (this.BASE.$browser().ule) {
      //邮乐app
      // 创建script标签，引入外部文件
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "//i0.ulecdn.com/app/yxd/j/yl/dsbridge.js";
      document.getElementsByTagName("head")[0].appendChild(script);
    } else {
      if (this.BASE.$browser().wx) {
        let script3 = document.createElement("script");
        script3.type = "text/javascript";
        script3.src = "//i1.ulecdn.com/app/yxd/j/lib/zepto.min.js";
        document.getElementsByTagName("head")[0].appendChild(script3);
      }
    }
    this.initWxSahre();
  },
  methods: {
    initWxSahre() {
      //微信内调用微信分享
      if (this.BASE.$browser().wx) {
        let script1 = document.createElement("script");
        script1.type = "text/javascript";
        script1.src = "https://res.wx.qq.com/open/js/jweixin-1.0.0.js";
        document.getElementsByTagName("head")[0].appendChild(script1);
        setTimeout(res => {
          this.init();
        }, 2000);
      }
    },
    shareWX() {
      var oThis = this;
      var uleUrl = "ule.com";
      //var _openId = location.href.getQueryValue('openId') ||location.href.getQueryValue('openid') || "";//wx8b73da0067c52318
      var _appId = "";
      var _uleUrl = "";
      if (uleUrl == "ule.com") {
        // _uleUrl = "www.ulecdn.com"; // 生产appid
        _appId = "wx4e190edda7e57237";
      } else {
        // _uleUrl = "beta.ulecdn.com"; // 测试appid
        _appId = "wx8b73da0067c52318";
      }

      var _api = "//service.ule.com/api/mobile/getWechatSignature.do";
      ////service.' + uleUrl + '/api/mobile/getWechatSignature.do
      ////prize.' + uleUrl + '/json/WxSignature/FoucsSubscribe.action
      ////service.' + uleUrl + '/api/mobile/getWechatSignature.action
      var _data = {
        lotteryInfoId: 325,
        currentPageUrl: location.href,
        appkey: "4b9f40822ddd5cd5",
        version_no: "apr_2010_build01",
        appId: _appId,
        t: Math.random()
      };
      // 获取微信参数
      $.ajax({
        url: _api,
        data: _data,
        dataType: "jsonp",
        jsonp: "jsonApiCallback",
        success: function(o) {
          console.log(o);
          if (o.returnCode == "0000") {
            oThis.wxConfig(
              o.detail[0].timestamp,
              o.detail[0].nonceStr,
              o.detail[0].signature,
              _appId
            );
          }
        }
      });
    },
    wxConfig(_timestamp, _nonceStr, _signature, _appId) {
      //alert('获取数据：'+_timestamp+'\n'+_nonceStr+'\n'+_signature);
      console.log(
        "获取数据：" + _timestamp + "\n" + _nonceStr + "\n" + _signature
      );
      let that = this;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: _appId, // 必填，公众号的唯一标识
        timestamp: _timestamp, // 必填，生成签名的时间戳
        nonceStr: _nonceStr, // 必填，生成签名的随机串
        signature: _signature, // 必填，签名，见附录1
        jsApiList: [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo"
        ]
        // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function() {
        console.log("微信分享功能初始化成功");
        if (that.wxshare_desc != null && that.wxshare_desc.length > 50) {
          that.wxshare_desc = that.wxshare_desc.substring(0, 50) + "...";
        }
        // 分享到朋友圈
        wx.onMenuShareTimeline({
          title: that.wxshare_desc, // 分享标题
          desc: that.wxshare_desc,
          link: that.wxshare_link, // 分享链接
          imgUrl: that.wxshare_imgurl, // 分享图标
          trigger: function(res) {
            // 用户点击分享后执行的回调函数
          },
          success: function(res) {
            // 用户确认分享后执行的回调函数
            shareSuc && shareSuc();
          },
          cancel: function(res) {
            // 用户取消分享后执行的回调函数
          },
          fail: function(res) {
            //alert(JSON.stringify(res));
          }
        });
        // 分享到朋友
        wx.onMenuShareAppMessage({
          title: that.wxshare_title, // 分享标题
          desc: that.wxshare_desc, // 分享描述
          link: that.wxshare_link, // 分享链接
          imgUrl: that.wxshare_imgurl, // 分享图标
          trigger: function(res) {
            // 用户点击分享后执行的回调函数
          },
          success: function(res) {
            // 用户确认分享后执行的回调函数
            shareSuc && shareSuc();
          },
          cancel: function(res) {
            // 用户取消分享后执行的回调函数
          },
          fail: function(res) {
            // alert(JSON.stringify(res));
          }
        });
        // 分享到QQ
        wx.onMenuShareQQ({
          title: that.wxshare_title, // 分享标题
          desc: that.wxshare_desc, // 分享描述
          link: that.wxshare_link, // 分享链接
          imgUrl: that.wxshare_imgurl, // 分享图标
          trigger: function(res) {
            // 用户点击分享后执行的回调函数
          },
          complete: function(res) {
            //alert(JSON.stringify(res));
          },
          success: function(res) {
            // 用户确认分享后执行的回调函数
            shareSuc && shareSuc();
          },
          cancel: function(res) {
            // 用户取消分享后执行的回调函数
          },
          fail: function(res) {
            //alert(JSON.stringify(res));
          }
        });
        // 分享到腾讯微博
        wx.onMenuShareWeibo({
          title: that.wxshare_title, // 分享标题
          desc: that.wxshare_desc, // 分享描述
          link: that.wxshare_link, // 分享链接
          imgUrl: that.wxshare_imgurl, // 分享图标
          trigger: function(res) {
            // 用户点击分享后执行的回调函数
          },
          complete: function(res) {
            // alert(JSON.stringify(res));
          },
          success: function(res) {
            // 用户确认分享后执行的回调函数
          },
          cancel: function(res) {
            // 用户取消分享后执行的回调函数
          },
          fail: function(res) {
            //alert(JSON.stringify(res));
          }
        });
      });
    },
    getParams() {
      var data = {};
      var href = decodeURIComponent(location.href);
      var paramStr = href.substring(href.indexOf("?") + 1);
      var paramArr = paramStr.split("&");
      for (var i = 0; i < paramArr.length; i++) {
        var item = paramArr[i];
        var keyVal = item.split("=");
        data[keyVal[0]] = keyVal[1];
      }
      return data;
    },
    init() {
      var oThis = this;
      oThis.param = oThis.getParams();
      oThis.shareWX();
    }
  },
  components: { index, sliderMenu }
};
</script>

<style>
@import "./assets/css/style.css";
body {
  background: #ff4900;
}
#app {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue